export default __webpack_public_path__ + "static/media/staking icon black.7ccbdd2d.svg";